import React from "react";

const WEEK_LABELS = ["日", "月", "火", "水", "木", "金", "土"];

function toDateKey(d) {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

/**
 * 運行日のカレンダー。
 *
 * 表で日付を縦に並べるより、「毎週この曜日は同じ」のような並びが目に入る。
 * 乗番ページ（その乗番に入った車両）と車号ページ（その車が入った乗番）で
 * 中身は違うが、**週の組み立ては同じ**なので枠だけ共通にする。
 *
 * 中身は renderCell に任せる。セルに何を出すかは呼ぶ側の都合で、
 * ここで分岐を抱えると両方の事情が混ざって読めなくなる。
 *
 * @param {number}   weeks      何週ぶん出すか
 * @param {Function} renderCell ({ key, isFuture }) => ReactNode | null
 */
export default function ServiceCalendar({ weeks = 5, renderCell }) {
  // 週の頭（日曜）に揃える。今週を最終週に置く
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const end = new Date(today);
  end.setDate(end.getDate() + (6 - end.getDay()));
  const start = new Date(end);
  start.setDate(start.getDate() - (weeks * 7 - 1));

  const rows = [];
  for (let w = 0; w < weeks; w++) {
    const days = [];
    for (let d = 0; d < 7; d++) {
      const date = new Date(start);
      date.setDate(start.getDate() + w * 7 + d);
      days.push({
        key: toDateKey(date),
        day: date.getDate(),
        isFuture: date > today,
      });
    }
    rows.push(days);
  }

  return (
    <div className="anl-cal">
      <div className="anl-cal__row anl-cal__row--head">
        {WEEK_LABELS.map((w, i) => (
          <div
            key={w}
            className={`anl-cal__head anl-cal__head--${i === 0 ? "sun" : i === 6 ? "sat" : "week"}`}
          >
            {w}
          </div>
        ))}
      </div>
      {rows.map((days, i) => (
        <div className="anl-cal__row" key={i}>
          {days.map((d) => {
            const content = renderCell(d);
            return (
              <div
                key={d.key}
                className={`anl-cal__cell${content ? " anl-cal__cell--has" : ""}${d.isFuture ? " anl-cal__cell--future" : ""}`}
                title={d.key}
              >
                <div className="anl-cal__date">{d.day}</div>
                {content ?? <div className="anl-cal__blank" />}
              </div>
            );
          })}
        </div>
      ))}
    </div>
  );
}
